import React from 'react'
import { Link, Outlet} from 'react-router-dom';

import "./css/project.css";
import {data} from "./projectdata";
const Project = () => {
    
    return (
        <>
        
        <div className='project-body'>
            <div className="card-outer">
            {data.map((item,index)=>(

                <div key={index} className="card-wrapper">
                    <div className="project-card">
                        <div className="project-card-heading"><h2>{item.name}</h2></div>
                        <div className="project-card-body">
                        <p>{item.description}</p>
                        </div>
                        <Link className="project-card-link" key={index} to={item.route}>View Project</Link>
                    </div>
                </div>
                ))}
            </div>
            
            <Outlet/>
                  
        </div>
        </>
       
    )
}

export default Project
